export default "__VITE_ASSET__LXxpP_zb__"